import { apiCall } from "./index";

export const getLeavePolicies = (page = 1, limit = 10) =>
  apiCall(`/leave-policies?page=${page}&limit=${limit}`);

export const getLeavePolicyById = (policyId) =>
  apiCall(`/leave-policies/${policyId}`);

export const createLeavePolicy = (policyData) =>
  apiCall(`/leave-policies`, "POST", policyData);

export const updateLeavePolicy = (policyId, policyData) =>
  apiCall(`/leave-policies/${policyId}`, "PUT", policyData);

export const deleteLeavePolicy = (policyId) =>
  apiCall(`/leave-policies/${policyId}`, "DELETE");

export const toggleLeavePolicyStatus = (policyId, isActive) =>
  apiCall(`/leave-policies/${policyId}/status`, "PATCH", { is_active: isActive });
